import { render } from "./DownloadMoovePage.vue?vue&type=template&id=f8d63a74&scoped=true"
import script from "./DownloadMoovePage.vue?vue&type=script&lang=js"
export * from "./DownloadMoovePage.vue?vue&type=script&lang=js"

import "./DownloadMoovePage.vue?vue&type=style&index=0&id=f8d63a74&scoped=true&lang=css"

import exportComponent from "/home/test/Documents/GitHub/LpMooveTrainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8d63a74"]])

export default __exports__